import { BehaviorSubject, EMPTY } from 'rxjs';
import { switchMap, tap } from 'rxjs/operators';

import Notification from '../models/Notification';

const defaultCriteria = {};

export default class NotificationsRepository {
  notifications$ = new BehaviorSubject([]);
  total$ = new BehaviorSubject(0);
  searchCriteria$ = new BehaviorSubject(defaultCriteria);
  searchSubscription;

  constructor({ socketService, notificationsService, authRepository }) {
    this.notificationsService = notificationsService;
    this.socketService = socketService;

    authRepository.auth$
      .pipe(
        tap(async (auth) => {
          if (auth) {
            await this.getUnreadNotifications();
          }
        })
      )
      .subscribe();

    this.searchSubscription = this.searchCriteria$.pipe(tap(async () => this.getUnreadNotifications())).subscribe();

    this.socketService.connected$
      .pipe(
        switchMap((connected) => {
          if (!connected) return EMPTY;

          return this.socketService.getChannel('notification').pipe(
            tap((notification) => {
              this.notifications$.next([...[new Notification(notification)], ...this.notifications$.getValue()]);
              this.total$.next(this.total$.getValue() + 1);
            })
          );
        })
      )
      .subscribe();
    // this.socketService.connected$.unsubscribe();
  }

  dispose() {
    this.searchSubscription.unsubscribe();
  }

  getSocketConnection$() {
    return this.socketService.connected$;
  }

  async getUnreadNotifications() {
    const notifications = await this.notificationsService.getUnreadNotifications(this.searchCriteria$.getValue());

    notifications.unreadNotifications = notifications.unreadNotifications?.map((item) => new Notification(item));
    this.notifications$.next(notifications.unreadNotifications);
    this.total$.next(notifications.total);
  }

  updateSearchCriteria(updatedCriteria) {
    this.searchCriteria$.next({
      ...this.searchCriteria$.getValue(),
      ...updatedCriteria,
    });
  }

  async readNotification(id) {
    await this.notificationsService.readNotification(id);
    this.notifications$.next(this.notifications$.getValue().filter((notification) => notification.id !== id));
    this.total$.next(this.total$.getValue() - 1);
  }

  async readAllNotification() {
    await this.notificationsService.readAllNotification();
    this.notifications$.next([]);
    this.total$.next(0);
  }

  sendMessage(channel, data) {
    this.socketService.sendMessage(channel, data);
  }

  subscribeChannel(channel) {
    return this.socketService.connected$.pipe(
      switchMap((connected) => {
        if (!connected) return EMPTY;

        return this.socketService.getChannel(channel);
      })
    );
  }
}
